module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_user_credit')) + " " + _vm._s(_vm.selectedUser != null ? ': ' + _vm.selectedUser.name + ' ' + _vm.selectedUser.name : ''))]), _vm._v(" "), _c('span', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.chooseUserDialog()
      }
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_choose_user')))])]), _vm._v(" "), _c('br')], 1), _vm._v(" "), (_vm.selectedUser != null) ? _c('div', {
    staticClass: "foo section-top-sm"
  }, [(_vm.selectedUser.profilePicture != null && _vm.selectedUser.profilePicture.length > 0) ? _c('img', {
    staticClass: "cropped1 user-avatar-lg",
    attrs: {
      "src": _vm.selectedUser.profilePicture
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedUser.profilePicture == null || _vm.selectedUser.profilePicture.length === 0) ? _c('img', {
    staticClass: "cropped1-missing user-avatar-lg",
    attrs: {
      "src": require("../../assets/img/icons/missing_image.svg")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-container section-top-sm"
  }, [_c('img', {
    staticClass: "user-coin-icon",
    attrs: {
      "src": require("../../assets/img/coin.png")
    }
  }), _vm._v(" "), _c('h2', {
    style: (_vm.currentCredits <= 0 ? 'color:red;' : 'color: green;')
  }, [_vm._v(_vm._s(_vm.currentCredits))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container section-top"
  }, [_c('div', {
    staticClass: "new-button credit-add-btn",
    on: {
      "click": function($event) {
        return _vm.addCredits()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_add_credits')))]), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.takeCredits()
      }
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_take_credits')))])])]) : _vm._e(), _vm._v(" "), (_vm.selectedUser != null) ? _c('div', {
    staticClass: "foo section-top"
  }, [_c('div', {
    class: _vm.selectedButton === 'ACTIVE' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('ACTIVE')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_credit_active')) + "\n    ")]), _vm._v(" "), _c('div', {
    class: _vm.selectedButton === 'HISTORY' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('HISTORY')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_credit_history')) + "\n    ")]), _vm._v(" "), _c('div', {
    class: _vm.selectedButton === 'USED' ? 'home-info-button-selected' : 'home-info-button',
    on: {
      "click": function($event) {
        return _vm.onTabClicked('USED')
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_credit_used')) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.selectedUser != null) ? _c('div', {
    staticClass: "row section-top-sm"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_us_type')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_us_amount')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_us_amount_used')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_us_created_date')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_us_valid_to')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userCredits), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_us_type')
      }
    }, [_vm._v(_vm._s(item.creditType))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_us_amount')
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_us_amount_used')
      }
    }, [_vm._v(_vm._s(item.amountUsed))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_us_created_date')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(item.timestamp)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_us_valid_to')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(item.validTo)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteCredit(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n              ")])])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('choose-user-modal', {
    attrs: {
      "show": _vm.chooseUser
    }
  }), _vm._v(" "), _c('add-user-credit', {
    attrs: {
      "show": _vm.userToAddCredit != null,
      "user": _vm.userToAddCredit,
      "addCredits": _vm.userAddCredits
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4fac0bf8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCredit/UserCredit.vue
// module id = 783
// module chunks = 0